export default __webpack_public_path__ + "342d9ef632c8698ef4f94074f355d680.webp";